import {
    settings
} from "./settings.js";
import * as PIXI from "pixi.js"

export const backgroundApp = new PIXI.Application({
    width: settings.originalWidth,
    height: settings.originalHeight,
    antialias: true,
    backgroundAlpha: 0,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
});

// document.getElementById('backgroundDiv').appendChild(backgroundApp.view)

export const frontApp = new PIXI.Application({
    // width: settings.originalWidth,
    // height: settings.originalHeight,
    // backgroundColor: 0x1E0A2A,
    backgroundAlpha: 0,
    antialias: true,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
});
// document.getElementById("frontDiv").appendChild(frontApp.view);

function appTransform(x, y) {
    frontApp.renderer.resize(x, y);
    backgroundApp.renderer.resize(x + 100, y + 100)
}

setTimeout(()=>{
  globalThis.__PIXI_APP__ = frontApp;

}, 1000)
// appTransform(800, 450)

// resize();

export function resize() {
  const gameContainer = document.getElementById('pixi-game-section')
  
  if (!gameContainer) {
    return 1;
  }

  frontApp.renderer.resize(gameContainer.offsetWidth, gameContainer.offsetHeight)
  if (backgroundApp && backgroundApp.renderer) {
    backgroundApp.renderer.resize(window.innerWidth, window.innerHeight)
  }

  let scale = gameContainer.offsetWidth > gameContainer.offsetHeight 
    ? gameContainer.offsetHeight / gameContainer.offsetWidth 
    : gameContainer.offsetWidth / gameContainer.offsetHeight
  return scale
}
